import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Home, Building2, Droplets, Fence, Waves, Car, Grid3X3, Sparkles, Eraser } from 'lucide-react';
import { API } from '../config/api';

export const SERVICE_ICON_MAP = {
  'roof-washing': Home,
  'house-washing': Building2,
  'gutter-cleaning': Droplets,
  'screen-enclosure-cleaning': Fence,
  'pool-deck-lanai-cleaning': Waves,
  'driveway-cleaning': Car,
  'fence-washing': Grid3X3,
  'window-cleaning': Sparkles,
  'rust-stain-removal': Eraser,
};

const ServicesContext = createContext({ services: [], loading: true });

export function ServicesProvider({ children }) {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/services`)
      .then((res) => {
        setServices(res.data.map((s) => ({ ...s, icon: SERVICE_ICON_MAP[s.slug] || Sparkles })));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <ServicesContext.Provider value={{ services, loading }}>
      {children}
    </ServicesContext.Provider>
  );
}

export function useServices() {
  return useContext(ServicesContext);
}
